import type {
  ConfirmationDetailsDto,
  ConfirmEventBodyDto,
} from '../core/events';
import type { HttpClient } from './http';
import { catch404ReturnNull } from './util';

export interface ConfirmationService {
  confirmEvent: (params: ConfirmEventBodyDto) => Promise<void>;
  getEventByUrlCode: (
    urlCode: string,
  ) => Promise<ConfirmationDetailsDto | null>;
}

export function createConfirmationService(
  httpClient: HttpClient,
  baseUrl: string,
): ConfirmationService {
  return {
    confirmEvent: (params: ConfirmEventBodyDto): Promise<void> => {
      return httpClient<void>(`${baseUrl}/events/confirmation`, 'post', {
        body: params,
      });
    },

    getEventByUrlCode: (
      urlCode: string,
    ): Promise<ConfirmationDetailsDto | null> => {
      return catch404ReturnNull(() =>
        httpClient<ConfirmationDetailsDto>(
          `${baseUrl}/confirmation_details/${urlCode}`,
          'get',
        ),
      );
    },
  };
}
